export default "__VITE_ASSET__1d6a61df__"